// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3ZsLE","header":"ReportDetails_header__3L2Hj","title":"ReportDetails_title__1_T7T","left":"ReportDetails_left__w-Hez"};